// An intentional, elegant frame shown wherever a family-approved
// photograph will eventually live. Never a broken-image box.
export const PhotoPlaceholder = ({
  alt,
  caption,
  badge,
  quote,
  ratio = "aspect-[4/5]",
  className = "",
  testId = "photo-placeholder",
}) => (
  <figure className={className} data-testid={testId}>
    <div
      role="img"
      aria-label={alt}
      className={`relative ${ratio} w-full overflow-hidden rounded-2xl border border-gold/40 bg-paper shadow-[inset_0_0_0_1px_rgba(212,163,115,0.15)]`}
    >
      <div className="absolute inset-0 flex flex-col items-center justify-center gap-3 p-6 text-center">
        <svg viewBox="0 0 48 48" className="h-10 w-10" fill="none" aria-hidden="true">
          <circle cx="24" cy="22" r="8" fill="#1BBEC3" opacity="0.85" />
          <path d="M8 31 H40" stroke="#0A2547" strokeWidth="2" strokeLinecap="round" />
          <path
            d="M24 6 V11 M12 11.5 L15 14.5 M36 11.5 L33 14.5"
            stroke="#1BBEC3"
            strokeWidth="1.8"
            strokeLinecap="round"
          />
          <path d="M10 31 C17 35.5 31 35.5 38 31" stroke="#8B3FDF" strokeWidth="1.4" strokeLinecap="round" />
        </svg>
        <p className="font-serif text-lg italic text-body">Family photo coming soon</p>
        <p className="max-w-[26ch] text-xs leading-relaxed text-muted-foreground">
          {alt}
        </p>
      </div>
      {badge && (
        <span className="absolute left-4 top-4 rounded-full bg-cream/90 px-3 py-1 text-xs font-semibold tracking-wide text-sage shadow-sm">
          {badge}
        </span>
      )}
    </div>
    {(caption || quote) && (
      <figcaption className="mt-3 text-center">
        {quote && <p className="font-serif text-base italic text-body">“{quote}”</p>}
        {caption && <p className="mt-1 text-sm text-muted-foreground">{caption}</p>}
      </figcaption>
    )}
  </figure>
);
